import { Link } from "react-router-dom";
import { useFetch } from "@/hooks/useFetch";
import { useSeo } from "@/hooks/useSeo";
import { media } from "@/lib/api";
import { dateOnly } from "@/lib/format";

export default function Journal() {
  const { data, loading } = useFetch("/store/journal");
  useSeo("The Journal", "Editorial on designers, craft and the seasons.");
  const items = data?.items || [];
  return (
    <div className="container-lux pt-8 pb-20" data-testid="journal-page">
      <nav className="text-xs text-muted-foreground mb-6" data-testid="breadcrumbs"><Link to="/" className="hover:text-foreground">Home</Link><span className="mx-1.5">/</span><span className="text-foreground">Journal</span></nav>
      <header className="max-w-2xl mb-12"><h1 className="text-5xl sm:text-6xl font-medium">The Journal</h1><p className="text-foreground/70 mt-4 leading-relaxed">Features, visits to ateliers and conversations with our designers.</p></header>
      {loading && <p className="text-sm text-muted-foreground">Loading…</p>}
      {!loading && items.length === 0 && <p className="text-sm text-muted-foreground" data-testid="journal-empty">No articles are published yet.</p>}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-14" data-testid="journal-grid">
        {items.map((a) => (
          <Link key={a.slug} to={`/journal/${a.slug}`} className="group" data-testid={`journal-card-${a.slug}`}>
            <div className="aspect-[3/2] bg-white rounded-md overflow-hidden">{a.hero_image_url && <img src={media(a.hero_image_url, 900)} alt="" className="w-full h-full object-cover img-zoom" loading="lazy" />}</div>
            <p className="eyebrow mt-5">{a.category || "Editorial"} · {dateOnly(a.published_at)}</p>
            <p className="font-display text-2xl mt-1.5 leading-tight group-hover:underline underline-offset-4">{a.title}</p>
            <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{a.excerpt}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
